import React, { Component } from 'react';
import IconeSobrescrito from './IconeSobrescrito';
import IconeAM from './IconeAM';

interface IPropsIconeHermesSobrescrito {
}


export default class IconeHermesSobrescrito extends React.Component<IPropsIconeHermesSobrescrito> {


    render() {
        return (
            <IconeSobrescrito>
                <IconeAM />
            </IconeSobrescrito>
        );
    }
}
